import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerElementosMacroubicacion = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerElementosMacroubicacion",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerElementosMacroubicacion };
